export class AreaCompetenza {
    id: number;
    label: string;
    colore: string;
    deletable: boolean;
  }

export enum AreaCompetenzaEnum {
    CALORE = 'CALORE',
    PUBBLICA = 'PUBBLICA',
    SEMAFORO = 'SEMAFORO',
    ALTRO = 'ALTRO',
    IDRAULICA = 'IDRAULICA'
};
